/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _actions from '../../actions';
import VersionFree from '../../components/structure/VersionFree.js';
import i18n from './../../i18n';
import moment from 'moment-timezone';
import constants from '../../constants';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";
import NewCalendar from '../../components/svg/NewCalendar';
import appStateProvider from '../../utilities/appStateProvider.js';

import { ActiveUsers, AppInstalls, Checkins, ContactFormSubmissions, EventRegistrations, LiveStreamViews, PageViews, SermonPlays, Sessions } from './AnalyticsElements.js';
import { AnalyticsFeatureGuard } from './AnalyticsFeatureGuard.js';
import { TextareaAutosize } from '@material-ui/core';

class AnalyticsPage extends React.Component {
    constructor(props) {
        super(props);
        const appState = appStateProvider();
        const anaylticsToken = appState.getAnalyticsToken();
        this.state = {
            token: anaylticsToken.token,  //this.props.profiles.token,
            isUnity: anaylticsToken.isUnity, //this.props.profiles.isUnity,
            tokenInput: localStorage.getItem("SessionId"), //this.props.profiles.token,
            analytics: null,
            landing: {},
            error: {},
            loading: true,
            showCustom: false,
            startDateTimeObject: moment().hour(0).minute(0).seconds(0).add(-30, 'days'),
            endDateTimeObject: moment().hour(23).minute(59).seconds(59).milliseconds(999),
            analyticsDateChoice: "30",
            analyticsDateOptions: [{label: 'Last 7 Days', value: '7'}, {
                label: 'Last 30 Days',
                value: '30'
            }, {label: 'Last 90 Days', value: '90'}, {label: 'Custom', value: 'Custom'}]
        };
    }

    componentDidMount() {

        if (typeof window.ANALYTICS_URL !== 'undefined') {
            this.initiateAnalytics();
        }
        document.body.classList.add('analytics-page', 'version-free');
        /* eslint-disable */
        let accountId = this.props.profiles.data.organizationId;
        let visitorId = this.props.profiles.data.id;        
		if(accountId && visitorId){
        (function (apiKey) {
            (function (p, e, n, d, o) {
                var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = [];
                v = ['initialize', 'identify', 'updateOptions', 'pageLoad']; for (w = 0, x = v.length; w < x; ++w) (function (m) {
                    o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
                })(v[w]);
                y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
            })(window, document, 'script', 'pendo');
            pendo.initialize({
                visitor: {
                    id: visitorId,
                },
                account: {
                    id: accountId,
                }
            });
        })('dec509d5-1495-45a2-65a5-0c7a69ff7ecb');    
		}
    }


    componentWillUnmount() {
        document.body.classList.remove('analytics-page', 'version-free');
    }

    clearWarning = () => {
        this.props.actions.clearAlert('data-warning');
    }
    handleStartDateChange = (e) => {
        const year = moment(e).format('YYYY');
        const month = parseInt(moment(e).format('MM')) - 1;
        const day = moment(e).format('DD');
        this.setState({startDateTimeObject: moment(this.state.StartDateTimeObject).year(year).month(month).date(day).hour(0).minute(0).seconds(0)});
    }


    handleEndDateChange = (e) => {
        const year = moment(e).format('YYYY');
        const month = parseInt(moment(e).format('MM')) - 1;
        const day = moment(e).format('DD');
        this.setState({endDateTimeObject: moment(this.state.EndDateTimeObject).year(year).month(month).date(day).hour(23).minute(59).seconds(59).milliseconds(999)});
    }

    openDatepicker1 = () => this._calendar1.setOpen(true);
    openDatepicker2 = () => this._calendar2.setOpen(true);
    updateDateChoice = (e) => {
        this.setState({analyticsDateChoice: e.value});
        if (e.value != 'Custom') {
            this.setState({
                showCustom: false,
                endDateTimeObject: moment().hour(23).minute(59).seconds(59).milliseconds(999),
                startDateTimeObject: moment().hour(0).minute(0).seconds(0).add(-e.value, 'Days')
            });
        } else {
            this.setState({showCustom: true});
        }

    }

    initiateAnalytics() {
        if (window.com?.mb?.analytics && !this.state.analytics) {
            window.com.mb.analytics.init();
            this.setState({ analytics: window.com?.mb?.analytics})
        } else {
            setTimeout(() => {
                this.initiateAnalytics();
            }, 500);
        }
    }

    onOpenCalendar = (e) => {
        let t = document.getElementsByClassName('month-selector');
        if (typeof window.SimpleBar != 'undefined') {
            const bars = function () {
                setTimeout(function () {
                    new window.SimpleBar(document.getElementsByClassName('Select-menu')[0]);
                }, 1);
            };
            for (var i = 0; i < t.length; i++) {
                t[i].addEventListener('click', bars, false);
            }
        }
    }

    setStateFromEvent = (e, stateKey) => {
        const stateObj = {};
        stateObj[stateKey] = e.target.value;
        this.setState(stateObj);
    }

    render() {
        const currentYear = (new Date()).getFullYear();
        const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
        const years = (range(currentYear, 2019, -1));
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];

        return (
            <VersionFree alerts={this.props.alerts}>
                {(navigator.userAgent.indexOf('MSIE') !== -1
                    || navigator.appVersion.indexOf('Trident/') > -1) &&
                <div className='loading-form'>
                    Analytics is not available for Internet Explorer. Please use another browser.
                </div>}
                {!(navigator.userAgent.indexOf('MSIE') !== -1
                    || navigator.appVersion.indexOf('Trident/') > -1) &&
                <div data-qa="analytics-page" id="analytics-page" className="form-wrapper">
                    <h1 data-qa="analytics-page-header" id="analytics-page-header"
                        className="system left">{i18n.t('analytics.analytics')}</h1>
                        <AnalyticsFeatureGuard 
                            flags={this.props.flags} 
                            token={this.state.token} 
                            isUnity={this.state.isUnity} 
                            productType={constants.BridgeProductType} 
                            analyticsApiUrl={window.ANALYTICS_API_URL}>
                            <>
                                <div className='analytics-date-section' data-qa='analytics-date-section'>
                                    <Select
                                        id="analytics-date-options"
                                        options={this.state.analyticsDateOptions}
                                        className="form-selector"
                                        classNamePrefix="form-selector"
                                        value={this.state.analyticsDateOptions.find((f) => {
                                            return f.value === this.state.analyticsDateChoice;
                                        })}
                                        onChange={this.updateDateChoice}
                                        clearable={false}
                                        searchable={false}

                                    />
                                    {this.state.showCustom &&
                                    <div className='date-wrapper'>
                                        <DatePicker
                                            calendarClassName='range-calendar'
                                            showMonthDropdown
                                            showYearDropdown
                                            onCalendarOpen={this.onOpenCalendar}
                                            selected={moment(this.state.startDateTimeObject)
                                                .toDate()}
                                            onChange={this.handleStartDateChange}
                                            selectsStart
                                            startDate={moment(this.state.startDateTimeObject)
                                                .toDate()}
                                            endDate={moment(this.state.endDateTimeObject)
                                                .toDate()}
                                            popperPlacement="top-end"
                                            useWeekdaysShort={true}
                                            maxDate={moment().toDate()}
                                            ref={(c) => this._calendar1 = c}
                                            renderCustomHeader={({
                                                                    date,
                                                                    changeYear,
                                                                    changeMonth,
                                                                    decreaseMonth,
                                                                    increaseMonth,
                                                                    prevMonthButtonDisabled,
                                                                    nextMonthButtonDisabled
                                                                }) => (

                                                <div data-qa='datepicker-header'
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between"
                                                    }}
                                                >
                                                    <button data-qa='previousmonth' className='date-previous-month'
                                                            onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                        <svg width="11px" height="20px" viewBox="0 0 11 20" version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                                                            fillRule="evenodd">
                                                                <g id="analytics-date-picker-4"
                                                                transform="translate(-660.000000, -232.000000)">
                                                                    <g id="Components-/-Datepicker-/-Range"
                                                                    transform="translate(635.000000, 210.000000)">
                                                                        <g id="Left" transform="translate(16.000000, 16.000000)">
                                                                            <polygon id="Shape"
                                                                                    points="0 0 32 0 32 32 0 32"></polygon>
                                                                            <path
                                                                                d="M18.6205314,25.3333333 C18.5398612,25.3277998 18.519327,25.3284665 18.4394569,25.3147325 C18.2598492,25.2837312 18.0871085,25.2156616 17.934702,25.1156573 C17.857632,25.0651218 17.7903624,25.0063193 17.7231596,24.9435833 L9.72281669,16.9432404 C9.66761433,16.8841046 9.65221367,16.8706373 9.60321157,16.8060345 C9.54820921,16.7334981 9.50067384,16.6552948 9.46153883,16.5730246 C9.29059817,16.2136092 9.29059817,15.7871242 9.46153883,15.4277088 C9.50067384,15.3454386 9.54820921,15.2672353 9.60321157,15.1946988 C9.65221367,15.1301627 9.66761433,15.1166288 9.72281669,15.0575596 L17.7231596,7.05721674 C17.7822954,7.00201437 17.7958293,6.98654704 17.8603654,6.93761161 C18.0298394,6.8090061 18.2298479,6.72220238 18.4394569,6.68600083 C18.58913,6.66026639 18.7429366,6.66026639 18.8926097,6.68600083 C19.0122815,6.70666838 19.1290198,6.74373664 19.2386912,6.7958722 C19.6552424,6.99394736 19.9452548,7.40483164 19.9924568,7.8636513 C20.0110576,8.0449924 19.9920568,8.22966699 19.9369211,8.40340777 C19.8909858,8.5481473 19.8202494,8.68475316 19.7285122,8.80569167 C19.6795101,8.87029444 19.6641094,8.88376169 19.608907,8.94289755 L12.5514046,16.0004 L19.608907,23.0579025 L19.671043,23.1244387 C19.7220452,23.187108 19.7365792,23.2017086 19.7809811,23.2694449 C19.8642513,23.3963837 19.9255873,23.537523 19.9615222,23.684996 C19.9902567,23.8030011 20.0027906,23.924873 19.9986571,24.0462115 C19.9829231,24.5072313 19.7215785,24.9369163 19.3195613,25.1629927 C19.1872223,25.2373959 19.0422161,25.2889314 18.8926097,25.3147325 C18.8127396,25.3284665 18.7922054,25.3277998 18.7115353,25.3333333 L18.6205314,25.3333333 L18.6205314,25.3333333 Z"
                                                                                id="Shape" fill="#616B7D"></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <Select  className="month-selector"
                                                            classNamePrefix="month-selector"
                                                            value={{value: months[getMonth(date)], label: months[getMonth(date)]}}
                                                            options={months.map(option => ({value: option, label: option}))}
                                                            isSearchable={false} isClearable={false}
                                                            onChange={(e) => {
                                                                changeMonth(months.indexOf(e.value))
                                                            }}
                                                    />
                                                    <Select className="year-selector"
                                                            classNamePrefix="month-selector"
                                                            value={{value: getYear(date), label: getYear(date)}}
                                                            options={years.map(option => ({value: option, label: option}))}
                                                            isSearchable={false} isClearable={false}
                                                            onChange={(e) => {
                                                                changeYear(e.value)
                                                            }}/>


                                                    <button data-qa='next-month' className='date-next-month' onClick={increaseMonth}
                                                            disabled={nextMonthButtonDisabled}>
                                                        <svg width="11px" height="20px" viewBox="0 0 11 20" version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                                                            fillRule="evenodd">
                                                                <g id="analytics-date-picker-9"
                                                                transform="translate(-911.000000, -232.000000)">
                                                                    <g id="Components-/-Datepicker-/-Range"
                                                                    transform="translate(635.000000, 210.000000)">
                                                                        <g id="Right" transform="translate(264.000000, 16.000000)">
                                                                            <polygon id="Shape"
                                                                                    points="0 0 32 0 32 32 0 32"></polygon>
                                                                            <path
                                                                                d="M21.287198,25.3333333 C21.2065279,25.3277998 21.1859937,25.3284665 21.1061236,25.3147325 C20.9265159,25.2837312 20.7537752,25.2156616 20.6013686,25.1156573 C20.5242987,25.0651218 20.4570291,25.0063193 20.3898262,24.9435833 L12.3894834,16.9432404 C12.334281,16.8841046 12.3188803,16.8706373 12.2698782,16.8060345 C12.2148759,16.7334981 12.1673405,16.6552948 12.1282055,16.5730246 C11.9572648,16.2136092 11.9572648,15.7871242 12.1282055,15.4277088 C12.1673405,15.3454386 12.2148759,15.2672353 12.2698782,15.1946988 C12.3188803,15.1301627 12.334281,15.1166288 12.3894834,15.0575596 L20.3898262,7.05721674 C20.4489621,7.00201437 20.462496,6.98654704 20.5270321,6.93761161 C20.696506,6.8090061 20.8965146,6.72220238 21.1061236,6.68600083 C21.2557967,6.66026639 21.4096033,6.66026639 21.5592763,6.68600083 C21.6789481,6.70666838 21.7956865,6.74373664 21.9053578,6.7958722 C22.321909,6.99394736 22.6119215,7.40483164 22.6591235,7.8636513 C22.6777243,8.0449924 22.6587235,8.22966699 22.6035878,8.40340777 C22.5576525,8.5481473 22.4869161,8.68475316 22.3951788,8.80569167 C22.3461767,8.87029444 22.3307761,8.88376169 22.2755737,8.94289755 L15.2180713,16.0004 L22.2755737,23.0579025 L22.3377097,23.1244387 C22.3887119,23.187108 22.4032459,23.2017086 22.4476478,23.2694449 C22.530918,23.3963837 22.592254,23.537523 22.6281888,23.684996 C22.6569234,23.8030011 22.6694573,23.924873 22.6653238,24.0462115 C22.6495897,24.5072313 22.3882452,24.9369163 21.986228,25.1629927 C21.853889,25.2373959 21.7088828,25.2889314 21.5592763,25.3147325 C21.4794063,25.3284665 21.458872,25.3277998 21.3782019,25.3333333 L21.287198,25.3333333 L21.287198,25.3333333 Z"
                                                                                id="Shape" fill="#616B7D"
                                                                                transform="translate(17.333029, 16.000000) scale(-1, 1) translate(-17.333029, -16.000000) "></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                </div>
                                            )}
                                        />
                                        <span className="calendar" onClick={this.openDatepicker1}><NewCalendar/></span>
                                    </div>}
                                    {this.state.showCustom && <div className='date-divider'></div>}
                                    {this.state.showCustom &&
                                    <div className='date-wrapper'>
                                        <DatePicker
                                            calendarClassName='range-calendar'
                                            showMonthDropdown
                                            showYearDropdown
                                            onCalendarOpen={this.onOpenCalendar}
                                            ref={(c) => this._calendar2 = c}
                                            selected={moment(this.state.endDateTimeObject)
                                                .toDate()}
                                            onChange={this.handleEndDateChange}
                                            selectsEnd
                                            startDate={moment(this.state.startDateTimeObject)
                                                .toDate()}
                                            endDate={moment(this.state.endDateTimeObject)
                                                .toDate()}
                                            minDate={moment(this.state.startDateTimeObject)
                                                .toDate()}
                                            maxDate={moment().toDate()}
                                            popperPlacement="top-end"
                                            useWeekdaysShort={true}
                                            renderCustomHeader={({
                                                                    date,
                                                                    changeYear,
                                                                    changeMonth,
                                                                    decreaseMonth,
                                                                    increaseMonth,
                                                                    prevMonthButtonDisabled,
                                                                    nextMonthButtonDisabled
                                                                }) => (

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between"
                                                    }}
                                                >
                                                    <button className='date-previous-month' onClick={decreaseMonth}
                                                            disabled={prevMonthButtonDisabled}>
                                                        <svg width="11px" height="20px" viewBox="0 0 11 20" version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                                                            fillRule="evenodd">
                                                                <g id="analytics-date-picker-4"
                                                                transform="translate(-660.000000, -232.000000)">
                                                                    <g id="Components-/-Datepicker-/-Range"
                                                                    transform="translate(635.000000, 210.000000)">
                                                                        <g id="Left" transform="translate(16.000000, 16.000000)">
                                                                            <polygon id="Shape"
                                                                                    points="0 0 32 0 32 32 0 32"></polygon>
                                                                            <path
                                                                                d="M18.6205314,25.3333333 C18.5398612,25.3277998 18.519327,25.3284665 18.4394569,25.3147325 C18.2598492,25.2837312 18.0871085,25.2156616 17.934702,25.1156573 C17.857632,25.0651218 17.7903624,25.0063193 17.7231596,24.9435833 L9.72281669,16.9432404 C9.66761433,16.8841046 9.65221367,16.8706373 9.60321157,16.8060345 C9.54820921,16.7334981 9.50067384,16.6552948 9.46153883,16.5730246 C9.29059817,16.2136092 9.29059817,15.7871242 9.46153883,15.4277088 C9.50067384,15.3454386 9.54820921,15.2672353 9.60321157,15.1946988 C9.65221367,15.1301627 9.66761433,15.1166288 9.72281669,15.0575596 L17.7231596,7.05721674 C17.7822954,7.00201437 17.7958293,6.98654704 17.8603654,6.93761161 C18.0298394,6.8090061 18.2298479,6.72220238 18.4394569,6.68600083 C18.58913,6.66026639 18.7429366,6.66026639 18.8926097,6.68600083 C19.0122815,6.70666838 19.1290198,6.74373664 19.2386912,6.7958722 C19.6552424,6.99394736 19.9452548,7.40483164 19.9924568,7.8636513 C20.0110576,8.0449924 19.9920568,8.22966699 19.9369211,8.40340777 C19.8909858,8.5481473 19.8202494,8.68475316 19.7285122,8.80569167 C19.6795101,8.87029444 19.6641094,8.88376169 19.608907,8.94289755 L12.5514046,16.0004 L19.608907,23.0579025 L19.671043,23.1244387 C19.7220452,23.187108 19.7365792,23.2017086 19.7809811,23.2694449 C19.8642513,23.3963837 19.9255873,23.537523 19.9615222,23.684996 C19.9902567,23.8030011 20.0027906,23.924873 19.9986571,24.0462115 C19.9829231,24.5072313 19.7215785,24.9369163 19.3195613,25.1629927 C19.1872223,25.2373959 19.0422161,25.2889314 18.8926097,25.3147325 C18.8127396,25.3284665 18.7922054,25.3277998 18.7115353,25.3333333 L18.6205314,25.3333333 L18.6205314,25.3333333 Z"
                                                                                id="Shape" fill="#616B7D"></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <Select className="month-selector"
                                                            classNamePrefix="month-selector"
                                                            value={{value: months[getMonth(date)], label: months[getMonth(date)]}}
                                                            options={months.map(option => ({value: option, label: option}))}
                                                            isSearchable={false} isClearable={false}
                                                            onChange={(e) => {
                                                                changeMonth(months.indexOf(e.value))
                                                            }}
                                                    />
                                                    <Select className="year-selector"
                                                            classNamePrefix="month-selector"
                                                            value={{value: getYear(date), label: getYear(date)}}
                                                            options={years.map(option => ({value: option, label: option}))}
                                                            isSearchable={false} isClearable={false}
                                                            onChange={(e) => {
                                                                changeYear(e.value)
                                                            }}/>


                                                    <button className='date-next-month' onClick={increaseMonth}
                                                            disabled={nextMonthButtonDisabled}>
                                                        <svg width="11px" height="20px" viewBox="0 0 11 20" version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                                                            fillRule="evenodd">
                                                                <g id="analytics-date-picker-9"
                                                                transform="translate(-911.000000, -232.000000)">
                                                                    <g id="Components-/-Datepicker-/-Range"
                                                                    transform="translate(635.000000, 210.000000)">
                                                                        <g id="Right" transform="translate(264.000000, 16.000000)">
                                                                            <polygon id="Shape"
                                                                                    points="0 0 32 0 32 32 0 32"></polygon>
                                                                            <path
                                                                                d="M21.287198,25.3333333 C21.2065279,25.3277998 21.1859937,25.3284665 21.1061236,25.3147325 C20.9265159,25.2837312 20.7537752,25.2156616 20.6013686,25.1156573 C20.5242987,25.0651218 20.4570291,25.0063193 20.3898262,24.9435833 L12.3894834,16.9432404 C12.334281,16.8841046 12.3188803,16.8706373 12.2698782,16.8060345 C12.2148759,16.7334981 12.1673405,16.6552948 12.1282055,16.5730246 C11.9572648,16.2136092 11.9572648,15.7871242 12.1282055,15.4277088 C12.1673405,15.3454386 12.2148759,15.2672353 12.2698782,15.1946988 C12.3188803,15.1301627 12.334281,15.1166288 12.3894834,15.0575596 L20.3898262,7.05721674 C20.4489621,7.00201437 20.462496,6.98654704 20.5270321,6.93761161 C20.696506,6.8090061 20.8965146,6.72220238 21.1061236,6.68600083 C21.2557967,6.66026639 21.4096033,6.66026639 21.5592763,6.68600083 C21.6789481,6.70666838 21.7956865,6.74373664 21.9053578,6.7958722 C22.321909,6.99394736 22.6119215,7.40483164 22.6591235,7.8636513 C22.6777243,8.0449924 22.6587235,8.22966699 22.6035878,8.40340777 C22.5576525,8.5481473 22.4869161,8.68475316 22.3951788,8.80569167 C22.3461767,8.87029444 22.3307761,8.88376169 22.2755737,8.94289755 L15.2180713,16.0004 L22.2755737,23.0579025 L22.3377097,23.1244387 C22.3887119,23.187108 22.4032459,23.2017086 22.4476478,23.2694449 C22.530918,23.3963837 22.592254,23.537523 22.6281888,23.684996 C22.6569234,23.8030011 22.6694573,23.924873 22.6653238,24.0462115 C22.6495897,24.5072313 22.3882452,24.9369163 21.986228,25.1629927 C21.853889,25.2373959 21.7088828,25.2889314 21.5592763,25.3147325 C21.4794063,25.3284665 21.458872,25.3277998 21.3782019,25.3333333 L21.287198,25.3333333 L21.287198,25.3333333 Z"
                                                                                id="Shape" fill="#616B7D"
                                                                                transform="translate(17.333029, 16.000000) scale(-1, 1) translate(-17.333029, -16.000000) "></path>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                </div>
                                            )}

                                        />
                                        <span className="calendar" onClick={this.openDatepicker2}><NewCalendar/></span>
                                    </div>
                                    }

                                </div>
                                <div className='analytics-timezone'
                                    data-qa='analytics-timezone'>Timezone: {moment.tz(moment.tz.guess()).zoneAbbr()}</div>
                                <div className='card-row'>
                                    <AppInstalls 
                                        className='card small' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                    <ActiveUsers 
                                        className='card small' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                    <Sessions 
                                        className='card small' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                    <Checkins 
                                        className='card small' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                </div>
                                <div className='card-row'>
                                    <PageViews 
                                        className='card large' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                </div>
                                <div className='card-row'>
                                    <LiveStreamViews 
                                        className='card medium' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                    <EventRegistrations 
                                        className='card medium' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                </div>
                                <div className='card-row'>
                                    <SermonPlays 
                                        className='card medium' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                    <ContactFormSubmissions 
                                        className='card medium' 
                                        token={this.state.token} 
                                        isUnity={this.state.isUnity}
                                        analytics={this.state.analytics} 
                                        startDate={this.state.startDateTimeObject} 
                                        endDate={this.state.endDateTimeObject} />
                                </div>
                                {window.genesisQA && <div>
                                    <TextareaAutosize
                                        value={this.state.tokenInput}
                                        name="token"
                                        onChange={e => this.setStateFromEvent(e, 'tokenInput')}
                                        id="txtToken"
                                    />
                                    <button id="btnFillChart" onClick={() => { this.setState({ token: this.state.tokenInput }); }}>Fill Charts</button>
                                </div>}
                            </>
                        </AnalyticsFeatureGuard>
                </div>}
            </VersionFree>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsPage);
